import { Module } from 'wrapper6'
import ProductService from '../services/_product-service'
import { debounce } from '../../utils/_debounce'

export default class ProductFilter extends Module {
  /*
	* Module is ready to run
	*/
  ready () {
    // Exit module if body class does not contain "archive"
    if (!document.body.classList.contains('archive')) {
      return
    }

    // Get Loader
    this.loader = document.getElementById('loader')

    // Get productlist
    this.productList = document.getElementById('products')

    // Exit if no product list
    if (!this.productList) return

    // Get current category
    this.currentCategory = this.productList.dataset.current

    // Set page number
    this.page = 1

    // Get Posts per Page filter
    this.ppp = document.getElementsByName('ppp')[0]

    this.ppp.addEventListener('change', () => {
      this.doFiltering()
    })

    // Get order filter
    this.orderby = document.getElementsByName('orderby')[0]
    this.orderby.addEventListener('change', () => {
      this.doFiltering()
    })

    // Get search filter
    this.search = ''
    this.searchfield = document.getElementById('search')
    this.searchfield.addEventListener('input', debounce(function () {
      if (this.searchfield.value && this.searchfield.value.length >= 3) {
        this.search = this.searchfield.value
        this.doFiltering()
      } else if (this.searchfield.value.length < 3) {
        this.search = ''
        this.doFiltering()
      }
    }.bind(this),
    250
    ))

    // Get taxonomy filters
    this.taxonomies = document.querySelectorAll('[data-taxonomy]')

    this.taxonomies.forEach((item) => {
      this.addClickListener(item)
    })

    // Get loadmore button
    this.loadmore = document.getElementById('loadmore')
    this.loadmore.addEventListener('click', () => {
      if (!this.loadmore.classList.contains('disabled')) {
        this.doFiltering(true)
      }
    })

    this.progressCount = document.getElementById('progress_count')
    this.progressIndicator = document.getElementById('progress-indicator')
  }

  /*
	* Add Click Event Listener to the passed element
	*/
  addClickListener (element) {
    element.addEventListener('change', () => {
      this.doFiltering()
    })
  }

  /*
	* Set Loader state
	*/
  setLoading (state) {
    if (state) {
      this.loader.classList.add('show')
    } else {
      this.loader.classList.remove('show')
    }
  }

  /*
	* Do the filtering of the products
	*/
  async doFiltering (nextPage) {
    this.setLoading(true)

    if (nextPage) {
      this.page++
    } else {
      this.page = 1
    }

    const data = await ProductService.getProducts({
      action: 'filter_products',
      search_word: this.search,
      categories: this.currentCategory,
      page: this.page,
      posts_per_page: this.ppp.value,
      order_by: this.orderby.value,
      taxonomies: this.getCheckedTaxonomies()
    })

    if (nextPage) {
      const Y = window.scrollY
      this.productList.insertAdjacentHTML('beforeend', data.html)
      window.scrollTo(0, Y)
    } else {
      this.productList.innerHTML = data.html
    }

    this.setPagination(data.pages, data.count)
    this.setLoading(false)
  }

  setPagination (pages, count) {
    if (pages === this.page) {
      this.loadmore.innerHTML = 'Alle produkter indlæst'
      this.loadmore.classList.add('disabled')
      this.loadmore.classList.add('white')
    } else {
      this.loadmore.innerHTML = 'Indlæs flere'
      this.loadmore.classList.remove('disabled')
      this.loadmore.classList.remove('white')
    }

    const shown = this.productList.getElementsByClassName('product').length

    this.progressCount.innerHTML = 'Du har nu set ' + shown + ' af ' + count + ' produkter'
    this.progressIndicator.style.width = (100 / count) * shown + '%'
  }

  getCheckedTaxonomies () {
    const checked = []

    this.taxonomies.forEach((taxonomy) => {
      if (taxonomy.checked || (taxonomy.type === 'select-one' && taxonomy.value !== '-1')) {
        checked.push(taxonomy.dataset.taxonomy)
        checked.push(taxonomy.value)
      }
    })

    return checked.join()
  }
}
